<template>
  <section class="documents-section" aria-label="Documentos oficiales">
    <div class="container">
      <tabs-section />
    </div>
  </section>
</template>
<script>
import TabsSection from "./JavascriptComponents/TabsSection";

export default {
  name: "DocumentsDownloads",
  components: {
    TabsSection,
  },
};
</script>
<style scoped>
.documents-section {
  position: relative;
  padding: 5rem 0;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    rgba(91, 69, 20, 0.18),
    rgba(6, 47, 54, 0.22)
  );
}

.documents-section::after {
  position: absolute;
  inset: 0;
  z-index: 0;
  content: "";
  background-image: radial-gradient(
      rgba(17, 81, 93, 0.08) 1px,
      transparent 0
    ),
    radial-gradient(rgba(169, 130, 37, 0.06) 1px, transparent 0);
  background-position: 0 0, 4px 4px;
  background-size: 4px 4px, 8px 8px;
  opacity: 0.5;
  pointer-events: none;
}

.container {
  position: relative;
  z-index: 1;
}

@media (max-width: 767px) {
  .documents-section {
    padding: 3.5rem 0;
  }
}

@media (max-width: 400px) {
  .documents-section {
    padding: 2.75rem 0;
  }
}
</style>
